import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ApplicationUtilsService } from '../../../services/application-utils/application-utils.service';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { Router } from '@angular/router';
import { AcAutomationRoutesLabels, AppRoutes, InbondStorageRoutes, RedeliveryRoutes } from '@shared/enums/app-routes.enum';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  @Input() buildVersion: string;

  @Output() releaseNotes = new EventEmitter<void>();

  email = 'LTLITEdgeRatingFeedback@xpo.com';
  subject = 'Feedback - Edge Accessorial Management';
  private readonly tabLabelsByRoute = [
    { path: `/${AppRoutes.STORAGE_ACCESSORIAL_CHARGES}`, label: AcAutomationRoutesLabels.storate },
    { path: `/${InbondStorageRoutes.main}`, label: AcAutomationRoutesLabels.inbondStorage },
    { path: `/${RedeliveryRoutes.main}`, label: AcAutomationRoutesLabels.redelivery },
    { path: `/${AppRoutes.DETENTION_WITH_POWER}`, label: 'Detention With Power - Single PRO' },
    { path: `/${AppRoutes.DETENTION_WITH_POWER_MULTI_PRO}`, label: 'Detention With Power - Multi PRO' },
  ];

  constructor(
    public configManagerService: ConfigManagerService,
    public applicationUtilsService: ApplicationUtilsService,
    private router: Router
  ) {}

  openHelpLink(): void {
    window.open(this.getHelpLink());
  }

  getHelpLink(): string {
    return this.applicationUtilsService.helpLink;
  }

  getMailLink(): string {
    return `mailto:${this.email}?subject=${this.getFeedbackSubject()}`;
  }

  private getFeedbackSubject(): string {
    const activeTabLabel = this.getActiveTabLabel();

    return activeTabLabel ? `${this.subject} - ${activeTabLabel}` : this.subject;
  }

  private getActiveTabLabel(): string | undefined {
    const currentUrl = this.router.url.split('?')[0].split('#')[0];
    const activeTab = this.tabLabelsByRoute.find(({ path }) => currentUrl === path || currentUrl.startsWith(`${path}/`));

    return activeTab?.label;
  }
}
